/* eslint-disable @typescript-eslint/no-explicit-any */

import { UniversitySearchResponse } from "utils/Types";
import { httpApi } from "./http.api";
import { ISearchLog } from "interfaces/ISearch";

//hiring/job/

export interface EmailFollowup {
  id?: number;
  frequency: number;
  template: number;
  project: number;
  search_log?: number;
  candidate_list?: number[];
}

export interface EmailFollowupResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: EmailFollowup[];
}


export const getSearchList = (
  page: number
): Promise<{
  results: ISearchLog[];
  count: number;
  page: number;
  next: string | null;
  total_pages: number;
}> => httpApi.get<any>(`search/?page=${page}`).then(({ data }) => data);

export const getSearchResult = (text: string): Promise<any[]> =>
  httpApi
    .get<any[]>(`explorator/autocomplete-companies/?text=${encodeURIComponent(text)}&industries=1`)
    .then((data: any) => {
      return data.data
        ? data.data.data
          ? data.data.data.autocomplete
            ? data.data.data.autocomplete.result
            : []
          : []
        : [];
    });

export const getSearchLog = (page = 1): Promise<any[]> =>
  httpApi.post<any[]>(`/search/?search_by_name=False&page=${page}`).then((data: any) => data.data);

export const getSkillSearchResult = (text: string): Promise<any[]> =>
  httpApi
    .get<any[]>(`explorator/autocomplete-skills/?text=${encodeURIComponent(text)}&titles=`)
    .then((data: any) => data.data);

export const getUniversitySearchResult = (text: string): Promise<UniversitySearchResponse> =>
  httpApi
    .get<any[]>(`explorator/autocomplete-universities/?text=${encodeURIComponent(text)}`)
    .then((data: any) => data.data);

export const getEducationLevelResult = (text: string): Promise<any[]> =>
  httpApi
    .get<any[]>(`explorator/autocomplete-education-levels/?text=${encodeURIComponent(text)}`)
    .then((data: any) => data.data);

export const getEducationFieldResult = (text: string): Promise<any[]> =>
  httpApi
    .get<any[]>(`explorator/autocomplete-education-fields/?text=${encodeURIComponent(text)}`)
    .then((data: any) => data.data);

export const getJobTitleResult = (text: string): Promise<any[]> =>
  httpApi
    .get<any[]>(`explorator/autocomplete-job-title/?text=${encodeURIComponent(text)}&industries=`)
    // .then((data: any) => data.data);
    .then((data: any) => {
      return data.data
        ? data.data.data
          ? data.data.data.autocomplete
            ? data.data.data.autocomplete.result
            : []
          : []
        : [];
    });

export const getIndustryResult = (text: string): Promise<any[]> =>
  httpApi
    .get<any[]>(
      `explorator/autocomplete-companies/?text=${encodeURIComponent(text)}&search_by_industry=true`
    )
    .then((data: any) => data.data);

export const getIndustryGrpResult = (text: string): Promise<any[]> =>
  httpApi
    .get<any[]>(
      `explorator/autocomplete-industries/?text=${encodeURIComponent(text)}&search_by_industry=true`
    )
    .then((data: any) => data.data);

export const getIndustryGrpLeaderResult = (text: string): Promise<any[]> =>
  httpApi
    .get<any[]>(`explorator/autocomplete-industries/?text=${text}&search_by_industry=false`)
    .then((data: any) => data.data);
export const getIndustryLeaderResult = (text: string): Promise<any[]> =>
  httpApi
    .get<any[]>(
      `explorator/autocomplete-companies/?text=${encodeURIComponent(text)}&search_by_industry=false`
    )
    .then((data: any) => data.data);

export const getSearchStats = (search_id: any, filters_criteria: any): Promise<any[]> =>
  httpApi
    .post<any[]>(`search/stats/?search_id=${search_id}`, {
      search_id: search_id,
      filters_criteria,
    })
    .then((data: any) => data.data);

export const getCandidateList = (candidateIds: any): Promise<any[]> =>
  httpApi
    .post<any[]>("candidate/custom-candidates/get-candidates/", {
      ids: candidateIds,
    })
    .then((data: any) => data.data);

export const getIndustryByType = (data: {
  fortune_100: boolean;
  fortune_500: boolean;
  fortune_1000: boolean;

  text: string;
}): Promise<any[]> =>
  httpApi.post<any[]>("company/fortune-companies/", data).then((data: any) => data.data);
export const getModelCandidateProfileResult = (payload: any): Promise<any[]> =>
  httpApi.post<any[]>("explorator/ideal-candidate/", payload).then((data: any) => data.data);

export const startSearching = (payload: any, config: any = {}): Promise<any[]> =>
  httpApi
    .post<any[]>(
      "/search/",
      {
        ...payload,
      },
      { signal: config.signal }
    )
    .then((data: any) => data.data);

export const updateSearch = (searchId: any, payload: any, config: any = {}): Promise<any[]> =>
  httpApi
    .put<any[]>(
      `/search/${searchId}/`,
      {
        ...payload,
      },
      { signal: config.signal }
    )
    .then((data: any) => data.data);

export const filterSearchResult = (payload: any, config: any = {}): Promise<any[]> =>
  httpApi
    .post<any[]>(
      "/search/results/",
      {
        ...payload,
      },
      { signal: config.signal }
    )
    .then((data: any) => data.data);

export const getMainSearchResult = (
  searchResultId: any,
  search_wizard_config: any = {},
  page = 1,
  filterData: any = {},
  filterId: any = null
): Promise<any[]> => {
  const payload = {
    search_id: searchResultId,
    search_wizard_config: search_wizard_config,
    page: page,
    // filters_criteria_id: parseInt(filterId) || null,
    ...filterData,
  };
  if (filterId) {
    payload["filters_criteria_id"] = parseInt(filterId);
  }
  return httpApi
    .post<any[]>(`/search/results/?page=${page}`, payload)
    .then((data: any) => data.data);
};

export const getAgencyData = (isMartech?: boolean): Promise<any[]> =>
  httpApi.get<any[]>(`explorator/agency-tree/?martech=${isMartech}`).then((data: any) => data.data);

export const getSuggestedSkills = (skills: any) => {
  return httpApi.post<any[]>("explorator/suggest-skills", skills).then((data: any) => data.data);
};

export const getWebSearch = (candidateId: any) => {
  return httpApi
    .post<any[]>("/candidate/details/web-search/", { candidate: candidateId })
    .then((data: any) => data.data);
};

export const deleteSearch = (searchId: any) => {
  return httpApi.delete<any[]>(`search/${searchId}/`).then((data: any) => data.data);
};

export const getSearchLogDetails = (searchId: any) => {
  return httpApi.get<any[]>(`/search/${searchId}/`).then((data: any) => data.data);
};

export const rejectFromSearch = (rejectPayload: {
  candidates: any[];
  is_rejected: boolean;
  search_id: any;
}) => {
  return httpApi
    .post<any[]>("/search/action/reject-from-search/", rejectPayload)
    .then((data: any) => data.data);
};

export const getRecentSearchList = (pageNo = 1): Promise<any[]> =>
  httpApi.get<any[]>(`/search/?page=${pageNo}`).then((data: any) => data.data);

export const getSavedSearch = (page = 1): Promise<any[]> =>
  httpApi.get<any[]>(`/search/?is_saved=true&page=${page}`).then((data: any) => data.data);

export const getProjectSavedSearchList = (project_id: any, pageNo = 1): Promise<any[]> =>
  httpApi
    .get<any[]>(`/search/?is_saved=true&page=${pageNo}&job_id=${project_id}`)
    .then((data: any) => data.data);

export const saveSearchMark = (
  searchId: any,
  is_saved: boolean,
  filters_criteria: any = null
): Promise<any[]> =>
  httpApi
    .post<any[]>("/search/action/save-search/", {
      search_id: searchId,
      is_saved: is_saved,
      filters_criteria: filters_criteria ? filters_criteria : {},
    })
    .then((data: any) => data.data);

export const searchByName = (
  payload: any,
  search_wizard_config: any = {},
  roleId: any = null,
  page = 1
): Promise<any[]> =>
  httpApi
    .post<any[]>("/search/", {
      ...payload,
      search_wizard_config: search_wizard_config,
      page: page,
      search_by_name: true,
      job: roleId,
    })
    .then((data: any) => data.data);

export const cancelSearch = (searchId: any): Promise<any[]> =>
  httpApi
    .post<any[]>("/search/action/cancel-search/", {
      search_id: searchId,
      is_saved: false,
    })
    .then((data: any) => data.data);
//{{alpha_url}}/search/?only_search_prompts=True
export const getSearchPrompts = (): Promise<{
  count: number;
  results: any[];
}> => httpApi.get<any[]>("/search/?only_search_prompts=True").then((data: any) => data.data);

export const getCompanyGroups = (count: number, page?: number): Promise<any> =>
  httpApi
    .get<any[]>(`/company/company-groups/?ordering-companies_count=${count}&page=${page}`)
    .then((data: any) => data.data);

export const getProjectRecentSearchList = (project_id: any, pageNo = 1): Promise<any[]> =>
  httpApi.get<any[]>(`/search/?page=${pageNo}&job_id=${project_id}`).then((data: any) => data.data);

export const uploadJobDescription = (formData: any): Promise<any> =>
  httpApi
    .post<any[]>("/search/file-parser/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((data: any) => data.data);


export const getGoodAndBadMatchCount = (searchId: any) => {
  return httpApi.get<any[]>(`/search/candidates/${searchId}/`).then((data: any) => data.data);
};

export const addSearchFeedback = async ({ user_feedback, step_number, search_type, search_id }: any) => {
  return httpApi.patch<any[]>(`search/${search_id}/`, { user_feedback, step_number, search_type }).then((data: any) => data.data);
};

export const getShortlistedCandidates = (
  projectId: number,
  page?: number,
  search?: string,
  sortBy?: string,
  sortOrder?: string,
  interviewStatuses?: string,
  selectAll = true
): Promise<any> => {
  const params = new URLSearchParams();

  if (page) params.append('page', page.toString());
  if (search) params.append('search', search);
  if (sortBy) params.append('sort_by', sortBy);
  if (sortOrder) params.append('sort_order', sortOrder);
  if (interviewStatuses) params.append('interview_statuses', interviewStatuses);
  if (selectAll) params.append('select_all', selectAll.toString());

  return httpApi.get<any[]>(`/hiring/shortlisted-candidates-for-job/${projectId}/?${params.toString()}`)
    .then((data: any) => data.data);
};

// Get all shortlisted candidates
export const getAllShortlistedCandidates = (projectId: number): Promise<any> => {
  return getShortlistedCandidates(projectId, undefined, undefined, undefined, undefined, undefined, true);
};

// Get shortlisted candidates with interview status "sent"
export const getSentInterviewCandidates = (projectId: number): Promise<any> => {
  return getShortlistedCandidates(projectId, undefined, undefined, undefined, undefined, 'sent', true);
};

// Get shortlisted candidates with interview status "completed"
export const getCompletedInterviewCandidates = (projectId: number): Promise<any> => {
  return getShortlistedCandidates(projectId, undefined, undefined, undefined, undefined, 'completed', true);
};

// Get shortlisted candidates with pagination and filtering
export const getFilteredShortlistedCandidates = (
  projectId: number,
  options: {
    page?: number;
    search?: any;
    sortBy?: string;
    sortOrder?: string;
    interviewStatuses?: string;
    selectAll?: boolean;
  } = {}
): Promise<any> => {
  return getShortlistedCandidates(
    projectId,
    options.page,
    options.search,
    options.sortBy,
    options.sortOrder,
    options.interviewStatuses,
    options.selectAll ?? true
  );
};

// Add this to your existing API service file

export const getAdvancedCandidateEvaluation = (payload: {
  sort_by_score: string;
  job_id: number;
  search_id?: number;
}): Promise<any> => {
  return httpApi
    .post<any[]>("/hiring/profile-advanced-evaluation/", payload)
    .then((data: any) => data.data);
};

export const createEmailFollowup = (payload: {
  frequency: number;
  template: number;
  project: number;
  search_log?: number;
}): Promise<EmailFollowup> =>
  httpApi
    .post<EmailFollowup>('/email_tracking/email-followup/', payload)
    .then(({ data }) => data);

export const editFollowup = (payload: {
  frequency: number;
  template: number;
  project: number;
  search_log?: number;
}): Promise<EmailFollowup> =>
  httpApi
    .put<EmailFollowup>("/email_tracking/email-followup/", payload)
    .then(({ data }) => data);

export const getEmailFollowups = (): Promise<EmailFollowupResponse> =>
  httpApi
    .get<EmailFollowupResponse>("/email_tracking/email-followup/")
    .then(({ data }) => data);


export const deleteEmailFollowup = (followupId: number): Promise<void> =>
  httpApi
    .delete(`/email_tracking/email-followup/${followupId}/`)
    .then(({ data }) => data);


// Search Questions API
export const searchQuestions = (searchLogId: number): Promise<any> =>
  httpApi
    .get(`/search/questions/?search_log=${searchLogId}`)
    .then(({ data }) => data);

export const searchQuestionsWithQuery = (searchLog: string): Promise<any> =>
  httpApi
    .get(`/search/questions/?search_log=${searchLog}`)
    .then(({ data }) => data);

export const createSearchQuestion = (payload: {
  search_log: number | string;
  question: string;
}): Promise<any> =>
  httpApi
    .post("/search/questions/", payload)
    .then(({ data }) => data);


export interface Company {
  name: string;
  year_from: number;
  year_to: number;
}

// Main request payload interface
export interface BooleanQueryPayload {
  skills: string[];
  job_title: string[];
  allow_previous_job_titles: boolean;
  min_experience: number;
  max_experience: number;
  company: Company[];
  companies_excluded: string[];
  locations: string[];
  must_have_keywords: string[];
  search_wizard_config: Record<string, any>;
  search_by_name: boolean;
  full_name: string | null;
  locations_excluded: string[];
  allow_previous_locations: boolean;
  industries: string[];
  universities: string[];
  keywords: string[];
  ever_worked: boolean;
}

// types/candidateCriteria.ts
export interface Question {
  id?: number;
  text: string;
  order: number;
}

export interface CandidateCriteria {
  id: number;
  question_set_id?: number;
  name: string;
  user?: number;
  questions: Question[];
  created?: string;
  modified?: string;
  recruiter?: number;
  shared_recruiters?: any[];
  actions_allowed?: {
    add_contributors?: boolean;
  };
}

export interface CandidateCriteriaResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: CandidateCriteria[];
}

// Search Boolean Query API
export const getBooleanQuery = (payload: any): Promise<any> =>
  httpApi
    .post("/search/action/get-boolean-query/", payload)
    .then(({ data }) => data);

export const getCandidateCriteria = (all = false): Promise<CandidateCriteriaResponse> =>
  httpApi
    .get(`/search/questions/?select_all=${all}`)
    .then(({ data }) => data);

export const createCandidateCriteria = (payload: Omit<CandidateCriteria, 'id'>): Promise<CandidateCriteria> =>
  httpApi
    .post("/search/questions/", payload)
    .then(({ data }) => data);

export const editCandidateCriteria = (id: number, payload: Partial<CandidateCriteria>): Promise<CandidateCriteria> =>
  httpApi
    .put(`/search/questions/${id}/`, payload)
    .then(({ data }) => data);

export const deleteCandidateCriteria = (id: number): Promise<void> =>
  httpApi
    .delete(`/search/questions/${id}/`)
    .then(({ data }) => data);

export const getCandidateCriteriaDetail = (id: number): Promise<CandidateCriteria> =>
  httpApi
    .get(`/search/questions/${id}/`)
    .then(({ data }) => data);